import { createSlice } from '@reduxjs/toolkit';

const modeSlice = createSlice({
  name: 'mode',
  initialState: {
    modes:"light",
    sideBarCollapes:'show',
    phoneToggle:'hide'
  },
  reducers: {
    setMode:(state)=>{
      state.modes = state.modes === "light" ? "dark" : "light";
    },
    setSideCollapes:(state)=>{
      state.sideBarCollapes = state.sideBarCollapes === "show" ? "hide" : "show";
    },
    setPhoneToggle:(state)=>{
      state.phoneToggle = state.phoneToggle === "hide" ? "show" : "hide";
    }
  },
});

export const { setMode,setSideCollapes,setPhoneToggle } = modeSlice.actions;
export default modeSlice.reducer